import React, { useState } from 'react';
import { Stack } from '@mui/material';
import { addDays } from 'date-fns';
import viewDaysCount from 'pages/WorkSchedulesPlanner/consts';
import { PlannerEmployee } from 'pages/WorkSchedulesPlanner/interfaces';
import { useAddScheduleEmployeeMutation } from 'store/scheduleEmployees/scheduleEmployees';
import { useAppDispatch } from 'store/hooks';
import { setErrorCatch, setSuccessStatus } from 'store/status/actions';
import { ScheduleEmployeeType } from 'store/scheduleEmployees/interfaces';
import { FormPayload } from 'pages/WorkSchedulesPlanner/EmployeeWorkSchedule/EmployeeDayScale/AddScheduleEmployeeForm/interfaces';
import dateFormat from 'dateformat';
import AddScheduleEmployeeForm from './AddScheduleEmployeeForm/AddScheduleEmployeeForm';

interface EmployeeDayScaleCellProps {
  startDate: Date;
  currentDate: Date;
  employee: PlannerEmployee;
}

export default function EmployeeDayScale({
  startDate,
  currentDate,
  employee,
}: EmployeeDayScaleCellProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const dispatch = useAppDispatch();
  const [addScheduleEmployee, { isLoading: addScheduleEmployeeLoading }] =
    useAddScheduleEmployeeMutation();

  const startDateDay = startDate.getDate();
  const isLastDayOfView =
    startDateDay === addDays(currentDate, viewDaysCount - 1).getDate();

  const handleAddScheduleEmployee = async (payload: FormPayload) => {
    try {
      const { dateFrom, dateTo, ...restPayload } = payload;

      await addScheduleEmployee({
        ...restPayload,
        dateFrom: dateFormat(dateFrom, 'yyyy-mm-dd'),
        ...(dateTo && { dateTo: dateFormat(dateTo, 'yyyy-mm-dd') }),
        employee: employee['@id'],
      }).unwrap();
      dispatch(setSuccessStatus(true));
      setIsModalOpen(false);
    } catch (error) {
      dispatch(setErrorCatch(error));
    }
  };

  return (
    <>
      <Stack
        sx={{
          borderRight: isLastDayOfView ? 'none' : '0.1rem solid',
          borderColor: 'border.main',
          backgroundColor: 'background.list',
          width: `calc(100% / ${viewDaysCount})`,
          height: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
          transition: 'background-color 0.3s',
          '&:hover': {
            backgroundColor: 'background.other',
          },
        }}
        onClick={() => setIsModalOpen(true)}
      />
      <AddScheduleEmployeeForm
        defaultValues={{
          schedule: '',
          dateFrom: startDate,
          dateTo: null,
          type: ScheduleEmployeeType.normal,
        }}
        employee={employee}
        isModalOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleAddScheduleEmployee}
        isSubmitting={addScheduleEmployeeLoading}
      />
    </>
  );
}
